import { ReactNode } from 'react';
import styles from './AboutUsSiteContainer.module.css';

interface Props {
  wider?: boolean;
  withVerticalGaps?: boolean;
  overlapAbove?: boolean;
  overlapBelow?: boolean;
  positionRelative?: boolean;
  twoColumn?: boolean;
  children: ReactNode;
}

const AboutUsSiteContainer = (props: Props) => (
  <div
    className={
      styles.siteContainer +
      ' ' +
      (props.wider ? styles.wider : '') +
      ' ' +
      (props.withVerticalGaps ? styles.withVerticalGaps : '') +
      ' ' +
      (props.positionRelative ? styles.positionRelative : '') +
      ' ' +
      (props.overlapAbove ? styles.overlapAbove : '') +
      ' ' +
      (props.overlapBelow ? styles.overlapBelow : '') +
      ' ' +
      (props.twoColumn ? styles.twoColumn : '')
    }
  >
    {props.children}
  </div>
);

export default AboutUsSiteContainer;
